import View from '../View';
import {
  CommerceOrderWrapperConstraint,
  SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
} from '@packages/systems/core/constants/SharedConstraintRules';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const config = createIntegratedAtom({
  displayName: 'Additional Info',
  showEmpty: true,
  constraints: {
    ancestors: [
      // @ts-expect-error - TS2322 - Type 'RelationshipConstraint | { readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]; readonly name: "Order Confirmation or Checkout Form"; readonly rule: "ExactlyOne"; } | { ...; }' is not assignable to type 'RelationshipConstraint'.
      ...SHARED_CHECKOUT_PAGE_SECTIONS_CONSTRAINTS,
      // @ts-expect-error - TS2322 - Type '{ readonly is: readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]; readonly name: "Order Confirmation or Checkout Form"; readonly rule: "ExactlyOne"; }' is not assignable to type 'RelationshipConstraint'.
      CommerceOrderWrapperConstraint,
      {
        // @ts-expect-error - TS2322 - Type 'string | string[] | UnsafeConstraintEscapeHatch | readonly ["CommerceCheckoutFormContainer", "CommercePaypalCheckoutFormContainer", "CommerceOrderConfirmationContainer"]' is not assignable to type 'string | string[] | UnsafeConstraintEscapeHatch'.
        is: 'CommerceCartWrapper',
        rule: 'Forbid',
      },
    ],
  },
  render: View,
  fields: {children: TListOfElement},
});

export default config;
